import { Injectable } from '@angular/core';
import { Route, Router, Routes } from '@angular/router';
import * as _ from 'lodash';
import { ContentComponent } from 'src/app/content/content.component';
import { MenuEntry } from 'src/app/header-menu/models/menu-entry.model';
import { TabService } from 'src/app/tabs/services/tab.service';
import { Tab } from 'src/app/tabs/models/tab.model';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  constructor(private router: Router, private tabService: TabService) { }

  public addingItemsInRouteConfig(itemsArr: MenuEntry[]): Routes {

    const mapFn = ({ items = [], ...o }: MenuEntry): Route => ({
      path: o.url,
      component: ContentComponent,
      data: { menuEntry: { ...o, items: [] }, title: o.label },
      children: items.map(mapFn)
    });

    const itemsMappedRouter: Routes = itemsArr.map((item: MenuEntry) => ({
      path: this.removeFirstSlashURL(item.url),
      component: ContentComponent,
      external: item.external,
      data: { menuEntry: { ...item, items: [] }, title: item.label },
      children: item.items.map(mapFn)
    } as Route)
    );
    this.router.config.unshift(...itemsMappedRouter);

    return itemsMappedRouter;
  }

  registerRoutes(routes: Route[], baseHref: string) {
    setTimeout(() => {
      // Sem early-return: os módulos lazy só têm as rotas filhas (_loadedConfig) disponíveis depois de
      // carregarem, pelo que o registo tem de poder ser refeito (o merge por módulo é feito mais abaixo)
      baseHref = this.removeFirstSlashURL(baseHref);

      if (routes === undefined) { return; }
      routes.forEach((root: any) => {
        const mapFn = ({ children = [], ...o }: Route): Route => ({
          path: o.path,
          outlet: o.outlet,
          component: ContentComponent,
          data: o.data,
          children: children.map(mapFn)
        });


        const defaultApp = {
          path: baseHref,
          component: ContentComponent,
          data: { menuEntry: {} },
          children: []
        } as Route;

        if (root) {
          const app = this.router.config.find(x => x.path === baseHref) || defaultApp;
          let itemsMappedRouter: Route[] = [];
          let module: Route;

          if (root._loadedConfig) {
            itemsMappedRouter = root._loadedConfig.routes.map((item: Route) => ({
              path: item.path,
              outlet: item.outlet,
              component: ContentComponent,
              data: item.data,
              children: item.children ? item.children.map(mapFn) : []
            } as Route));


            const urlPath = this.router.url.split('/');
            let routeFinder = root._loadedConfig.routes.filter(x => (
              x.path && root.path + '/' + x.path == urlPath[urlPath.length - 2] + '/' + urlPath[urlPath.length - 1]));
            if (routeFinder.length == 0) {
              root._loadedConfig.routes.forEach(element => {
                if (element.children && Array.isArray(element.children)) {

                  let minusOneIfEmpty = urlPath[0] == '' ? 1 : 0;

                  if (!routeFinder || (routeFinder && routeFinder.length == 0)) {

                    const reverseUrlPatch = urlPath.reverse();

                    routeFinder = element.children.find(x => x.path && x.path !== '' && (
                      x.path == urlPath[urlPath.length - 1] ||
                      reverseUrlPatch.findIndex(y => y == x.path) >= 0 ||
                      (
                        // if the path have "/:" that means that have params, so we need to compare the path without params!
                        x.path.includes('/:') && x.path.split('/:')[0] == urlPath[urlPath.length - x.path.split('/:').length] || (
                          x.path.includes('/:') && x.secondPath && x.secondPath == urlPath[urlPath.length - x.path.split('/:').length - minusOneIfEmpty] && !x.redirectTo)
                      )
                    ));

                    if (routeFinder && routeFinder.children) {
                      let routeFinderChildren = routeFinder.children.find(x => x.path && x.path !== '' && (
                        x.path == urlPath[urlPath.length - 1] ||
                        reverseUrlPatch.findIndex(y => x.path.includes('/:') && x.path.split('/:')[0] && y == x.path.split('/:')[0]) >= 0
                      ));

                      if (routeFinderChildren)
                        routeFinder = routeFinderChildren;

                    }
                  }
                }
              });
            }

            // Sem match profundo e com o URL na raiz do módulo (ex.: /mnm/dock-management), usar o título
            // da rota filha de path vazio (ignorada pelas heurísticas acima) ou o do próprio módulo,
            // para a tab ativa não ficar "Loading..." no primeiro carregamento
            if ((!routeFinder || (Array.isArray(routeFinder) && routeFinder.length == 0)) &&
              this.router.url.split('?')[0] == '/' + baseHref + '/' + root.path) {
              const emptyPathRoute = root._loadedConfig.routes.find(x => x.path == '' && x.data && x.data.title);
              if (emptyPathRoute) {
                routeFinder = emptyPathRoute;
              } else if (root.data && root.data.title) {
                routeFinder = root;
              } else {
                routeFinder = null;
              }
            }

            let routeFinderData = routeFinder;
            if (Array.isArray(routeFinder)) {
              routeFinderData = routeFinder.length == 1 ? routeFinder[0] : null;
            }

            module = {
              path: root.path,
              component: ContentComponent,
              data: routeFinderData && routeFinderData.data ? routeFinderData.data : { menuEntry: {}, title: '' },
              children: itemsMappedRouter
            } as Route;

            if (routeFinderData) this.tabService.addOrUpdateTab(_.cloneDeep({
              path: this.router.url,
              label: module.data ? module.data.title : '',
              data: module.data,
              component: module.component
            }) as Tab);

          } else {
            module = {
              path: root.path,
              component: root.component ? root.component : ContentComponent,
              outlet: root.outlet ? root.outlet : null,
              data: root.data,
              children: root.children ? root.children.map(mapFn) : []
            } as Route;
          }

          const moduleIndex = app.children.indexOf(app.children.find(x => x.path === module.path));
          moduleIndex > -1 ? app.children[moduleIndex] = module : app.children.push(module);

          if (!this.router.config.find(x => x.path === app.path)) {
            this.router.config.splice(0, 0, app);
          }
        }
      });
    });
  }

  mappingRoutes(routes: Route[], baseHref: string) {
    baseHref = this.removeFirstSlashURL(baseHref);
    let route = routes.find(x => x.path == baseHref) as Route
    return this.registerRoutes(route.children, baseHref);
  }

  public removeFirstSlashURL(url: string): string {
    if (!url) { return url; }
    return _.head(url).match('/') ? _.tail(url).join('') : url;
  }

  public removeParentPath(url: string): string {
    if (!url) { return url; }
    url = this.removeFirstSlashURL(url);
    return _.tail(url.split('/')).join('');
  }
}
